import React, { useState } from "react";
import HeroSection from "../components/HeroSection";
import { Link } from "react-router-dom";
import reviewsData from "../data/reviews.json";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";


function HomePage() {
  return (
    <div>
      <HeroSection />

      {/* About Our Services Section */}
      <section className="py-16 bg-gray-100">
        <div className="container mx-auto px-4 flex flex-col md:flex-row items-center gap-10">
          {/* Left: Image */}
          <div className="w-full md:w-1/2">
            <img
              src="/images/mtcgarage.jpg"
              alt="Garage and Auto Services"
              className="w-full rounded-lg shadow-md"
            />
          </div>

          {/* Right: Text */}
          <div className="w-full md:w-1/2 text-left">
            <h2 className="font-heading text-4xl text-center font-bold mb-4 text-primary">
              About Our Services
            </h2>
            <p className="font-body text-lg text-black-700 mb-4">
              Moving The Chainz has been serving the Birmingham area since 2015,
              offering reliable and expert automotive services. With over 10 years
              in business, we’ve built a reputation for quality and customer satisfaction.
            </p>
            <p className="font-body text-lg text-center text-black-700 mb-6">We specialize in:</p>
            <ul className="list-disc pl-5 mb-6 space-y-2 marker:text-secondary">
              <li className="text-lg italic text-center font-body text-black">Alignments</li>
              <li className="text-lg italic text-center font-body text-black">Suspensions</li>
              <li className="text-lg italic text-center font-body text-black">Brake services</li>
              <li className="text-lg italic text-center font-body text-black">Tire Rotations</li>
              <li className="text-lg italic text-center font-body text-black">Engine/Transmission Repair</li>
              <li className="text-lg italic text-center font-body text-black">Pre-Owned Car Sales</li>
              <li className="text-lg italic text-center font-body text-black">...and More!</li>

            </ul>
            <div className="flex justify-center flex-wrap gap-4">
              <Link
                to="/cars-for-sale"
                className="bg-primary text-white py-3 px-6 rounded-md hover:bg-primary/90 font-bold"
              >
                Browse Our Inventory
              </Link>
              <Link
                to="/contact"
                className="bg-secondary text-primary py-3 px-6 rounded-md hover:bg-secondary/80 font-bold"
              >
                Contact Us Now
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* Reviews Section */}
      <section className="py-12 bg-white">
        <div className="container mx-auto text-center">
          <h2 className="font-heading text-3xl font-bold mb-6 text-primary">
            What Our Customers Say
          </h2>
          <Swiper
            modules={[Navigation, Pagination, Autoplay]}
            slidesPerView={1}
            spaceBetween={30}
            loop={reviewsData.length > 1}
            navigation={reviewsData.length > 1}
            pagination={{ clickable: true }}
            autoplay={{ delay: 5000, disableOnInteraction: false }}
          >
            {reviewsData.map((review, index) => (
              <SwiperSlide key={index}>
                <div className="max-w-xl mx-auto p-6 bg-gray-100 border border-gray-300 rounded-lg shadow-lg">
                  <div className="mb-2">
                    {Array(review.rating)
                      .fill("")
                      .map((_, i) => (
                        <span key={i} className="text-yellow-500 text-xl mr-1">★</span>
                      ))}
                  </div>
                  <p className="font-body italic text-gray-800 mb-4 text-lg">"{review.text}"</p>
                  <p className="font-body text-sm text-gray-600">- {review.author}</p>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </section>

      {/* FAQ Section */}
      <section className="py-16 bg-gray-100">
        <div className="container mx-auto px-4">
          <h2 className="font-heading text-3xl font-bold mb-8 text-primary text-center">
            Frequently Asked Questions
          </h2>

          <div className="space-y-4 max-w-3xl mx-auto">
            {[
              {
                question: "What kinds of cars do you sell?",
                answer:
                  "We specialize in reliable, pre-owned vehicles across a range of makes and models everything from compact sedans to family SUVs. Every car goes through a multi-point inspection to ensure quality.",
              },
              {
                question: "How do you price your cars?",
                answer:
                  "Our prices are set based on current market values, vehicle condition, mileage, and age. We aim to keep our margins low so you get a fair deal on a dependable car.",
              },
              {
                question: "Do you offer financing?",
                answer:
                  "Yes, we handle financing in-house. We work out a plan that fits your budget and credit situation.",
              },
              {
                question: "How do I schedule a test drive?",
                answer:
                  "Give us a quick call/text at (205) 434-1344 to make sure the car you want to test drive is available. We’ll set aside the car and have it ready when you arrive.",
              },
               {
                question: "Do I need an appointment for service?",
                answer:
                  "Appointments help us minimize your wait, but we also accept same-day drop-ins when the bay is available. To guarantee a slot, please call us.",
              },
               {
                question: "How much do service appointments cost?",
                answer:
                  "We’ll always provide a written estimate for parts and labor before starting any work",
              },
               {
                question: "What auto repair services do you offer?",
                answer:
                  "Our shop handles routine maintenance (alignments, oil changes, brake service, tire rotations), diagnostics, engine/transmission repair, and more. All work is done by experienced technicians.",
              },
               {
                question: "What are your hours of operation?",
                answer:
                  "Sales: Mon–Sat, 9 am–6 pm, Service: Mon–Sat, 8 am–5 pm, Sunday: Closed",
              },
              
            ].map((faq, index) => (
              <FAQItem key={index} question={faq.question} answer={faq.answer} />
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}

// FAQ dropdown component
function FAQItem({ question, answer }) {
  const [open, setOpen] = useState(false);

  return (
    <div className="border border-gray-300 rounded-md shadow-sm bg-white">
      <button
        onClick={() => setOpen(!open)}
  className="w-full flex justify-between items-center px-6 py-4 font-heading text-xl text-left text-primary focus:outline-none"
      >
        <span>{question}</span>
        <svg
          className={`w-5 h-5 transform transition-transform duration-300 ${open ? "rotate-180" : ""}`}
          fill="none"
          stroke="currentColor"
          strokeWidth={2}
          viewBox="0 0 24 24"
        >
          <path strokeLinecap="round" strokeLinejoin="round" d="M19 9l-7 7-7-7" />
        </svg>
      </button>
      {open && (
        <div className="px-6 pb-4 text-gray-700 font-body text-base">
          {answer}
        </div>
      )}
    </div>
  );
}

export default HomePage;
